import { HttpClient } from '@wix/http-client';

import {
  LocateChargeRequest,
  LocateChargeResponse,
} from '@wix/ambassador-serverless-charge-locator-service/rpc';

const enum URLS {
  LOCATE_CHARGE = '/_serverless/charge-locator-service/v1/locate-charge',
}

export class ClientApi {
  private readonly http: HttpClient = new HttpClient({
    url: window.location.host,
  });

  locateInvoice({
    captchaToken,
    creditCard,
    invoiceNumber,
  }: LocateChargeRequest) {
    return this.http.post<LocateChargeResponse>(URLS.LOCATE_CHARGE, {
      captchaToken,
      creditCard,
      invoiceNumber,
    });
  }
}
